import './style.css'
// import GUI from 'lil-gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { gsap } from "gsap";




// Debug
// const gui = new GUI({
//     width: 400
// })

const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

//draco loader
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath( 'draco/' );

// GLTF loader
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

// Texture loader
const textureLoader = new THREE.TextureLoader()




// Canvas
const canvas = document.querySelector('canvas.webgl')

//scene
const scene = new THREE.Scene()
//scene.background = new THREE.Color(0xaba7a7);


/**
 * texture
 */
const bakedTexture = textureLoader.load('baked2.webp')
bakedTexture.flipY = false
bakedTexture.colorSpace = THREE.SRGBColorSpace

//materials

//baked material 
const bakedMaterial = new THREE.MeshBasicMaterial({
    map: bakedTexture
 })


// lights material
 const whiteEmmisionMaterial = new THREE.MeshBasicMaterial({ color: 0xffffe5  })
 const tailsMaterial = new THREE.MeshBasicMaterial({ color: 0xfc0303 })
 const thrustMaterial = new THREE.MeshStandardMaterial({ color: 0x03fcf8, emissive: 0x03fcf8, emissiveIntensity:100  })
 



 //fans
 const fans = []

 //spaceship
 const spaceship =[];

//model       
gltfLoader.load('spaceship.glb', (gltf)=>{
  let model = gltf.scene
  spaceship.push(gltf.scene)
  gsap.from(gltf.scene.scale, { x:0, y: 0, z:0, duration: 3,delay:0.8, ease: "expo.out" });


  const bakedMesh = model.children.find((child) => child.name === 'baked')
  bakedMesh.material = bakedMaterial

  const frontAMesh = model.children.find((child) => child.name === 'frontA')
  frontAMesh.material = whiteEmmisionMaterial

  const frontBMesh = model.children.find((child) => child.name === 'frontB')
  frontBMesh.material = whiteEmmisionMaterial

  const sidesMesh = model.children.find((child) => child.name === 'sides')
  sidesMesh.material = whiteEmmisionMaterial
  
  const thrustMesh = model.children.find((child) => child.name === 'thrust')
  thrustMesh.material = thrustMaterial
  
  const tailsMesh = model.children.find((child) => child.name === 'tails')
  tailsMesh.material = tailsMaterial
  

  //fans
  let fan1 = model.children.find((child) => child.name === 'fan1')
  let fan2 = model.children.find((child) => child.name === 'fan2')
  fans.push(fan1)
  fans.push(fan2)
  
  
 
  scene.add(model)

})


//camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 30
camera.position.y = 15
camera.position.z = 25

camera.lookAt(spaceship)
camera.updateProjectionMatrix()
scene.add(camera)





// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
//controls.enablePan = false
  



//renderer
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: true,
  alpha: true

})
renderer.setSize(sizes.width, sizes.height)
renderer.render(scene,camera)








/**
 * Animate
 */
const clock = new THREE.Clock()
const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    //spaceship
    spaceship.forEach(child => {
      
      child.position.y = (Math.sin(elapsedTime) - 0.5) * 2.0
      child.rotation.z = ((1-(Math.sin(elapsedTime)))-0.5) 
      child.rotation.z += ((Math.cos(elapsedTime)-0.5))  
      child.rotation.z *=  0.12 
      
    })
  
    
    //fans
    fans.forEach(fan => {
      if(fan.name == 'fan1'){
        fan.rotation.y = elapsedTime * 4
      }else{
        fan.rotation.y = (1 - elapsedTime) * 4
      }
    })

    
    // Update controls
    controls.update()

    

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()



gsap.from(".text", { opacity:0, y: 100, duration: 2,delay:0.4, ease: "expo.out" });
